// extracted by mini-css-extract-plugin
export default {"educationTypeButtonBox":"Education_educationTypeButtonBox__+R1Fc"};